import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import FloatingBrandPromo from "./pages/home/components/FloatingBrandPromo";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <FloatingBrandPromo />
    </BrowserRouter>
  );
}

export default App;
